<!-- <template>
  <div>
    <BankHolidays />

    <VacationPlanEmployee />
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import BankHolidays from '../components/BankHolidays.vue'
import Spinner from '../components/Spinner/Spinner.vue'


export default {
  components: {
    BankHolidays,
    Spinner,
  },
  computed: {
    ...mapGetters(['getIsLoading']),

  },
}

</script> -->
<template>
  <div class="home">
    <section
      class="main no-flex"
      style="margin-top: 13px;"
    >

      <BankHolidays />
      <!-- <UsersAttendance
        :user="user"
      /> -->
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
// import SaturdayWorkingHours from '../components/SaturdayWorkingHoursListing.vue'
// import UsersAttendance from '@/components/properties/UsersAttedance.vue'
import BankHolidays from '../components/BankHolidays.vue'


export default {
  name: 'Home',
  components: {
    BankHolidays,
    // UsersAttendance,
  },
  data() {
    return {
      user: '',
    }
  },
  computed: {
    ...mapGetters(['getIsLoading']),

  },
  methods: {
    materialId(id) {
      this.materialIdToShow = id
    },
    handleUser(id) {
      this.user = id;
    },
  },
}
</script>

<style scoped lang="scss">
@media screen and (max-width: 1041px) {
  .main {
    padding: 90px 0.75rem 15px 0.75rem;
  }
}
</style>
